<template>
	<div>

		<section class="page-banner page-banner-sec">
			<h1 class="section-title">{{ $t('courses.header')}}</h1>
		</section>
		<div>
			<toggle-button @change="toggleTheme" class="m-2 float-right" :value="themeValue" :width="60" :labels="{checked: 'Yes', unchecked: 'No'}"></toggle-button>
			<label class="float-right m-2">{{ $t('courses.grayscale')}}</label> 
		</div>

		<ClipLoader :loading="!loaded && !error" color="#5FB0E2" size="150px" class="p-5"></ClipLoader>

			<router-view v-if="loaded && !error" :style="{ filter: filter }"></router-view>
			<Error v-if="error" :message="error"></Error>
			

		

	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import { EventBus, mapNotificationEventActions } from '@/lib/events';
import { mapCommonFilters } from '@/lib/filters';
import { errHandler, errMessage } from '@/lib/handlers'
import { mapDebugActions } from '@/lib/debug';

import moment from 'moment'

export default {
	name: 'Therapy',
	components: {
		ClipLoader: () => import ('vue-spinner/src/ClipLoader'),
		Error:      () => import ('@/components/common/Error')
	},
	data () {
		return {
			loaded: false,
			error: false,
		}
	},
	watch: {
		$route: function (to, from) {
			this.debugMessage('<<THERAPY.VUE>> Route changed from ' + from.path + ' to ' + to.path);
			this.debugObject ({params: this.$route.params});
			//if (this.$route.name != 'therapy.content') {
			//	this.loaded = false;
			this.loadTherapy();
			//}
		}
	},
	mounted () {
		this.loadTherapy();
	},
	computed: {
		enrol_id () {
			return this.$route.params.enrol_id;
		},
		enrollments () {
			return this.$store.state.programs.enrollments;
		},
		enrollment () {
			return this.$store.state.programs.enrollments[this.enrol_id];
		},
		stage_id () {
			if (this.$route.params) return this.$route.params.stage_id;
		},
		task_id () {
			if (this.$route.params) return this.$route.params.task_id;
		},
		route () {
			return (this.$route.name) ? this.$route.name : '';
		},
		filter() {
   		 return this.$store.state.users.theme === 'grayscale' ? 'grayscale(100%)' : 'none';
  		},
		themeValue() {
			return this.$store.state.users.theme === 'grayscale' ? true : false;
		}
	},
	methods: {
		...mapActions(['fetchEnrollments', 'fetchSurveys', 'fetchCompleteSurveys', 'fetchStages', 'fetchStage', 'fetchGraphs']),
		...mapDebugActions,
		async loadTherapy () {
			this.loaded = false;
			this.error = false;

			if ( !this.enrollments || Object.keys(this.enrollments).length == 0 ) await this.fetchEnrollments();

			if (this.route == 'therapy') {
				this.debugMessage('<<THERAPY.VUE>> R0');
				this.loaded = true;
			} else {

				if (this.enrollment) {
					this.$store.commit('setEnrollment', this.enrollment);

					if (this.route == 'therapy.survey') {
						this.debugMessage('<<THERAPY.VUE>> R1');
						this.loaded = true;

					} else {

						if ( (this.route == 'therapy.content' || this.route == 'therapy.stage' ) && this.$route.params.stage_id) {
							this.debugMessage('<<THERAPY.VUE>> R2');
							this.debugObject ({params: this.$route.params});
							let stage_id = this.$route.params.stage_id;
							this.fetchStage({enrol_id: this.enrollment.id, stage_id: stage_id}).then((v) => {
								this.debugMessage('<<THERAPY.VUE>> R2>THEN');
								this.debugObject ({params: this.$route.params});
								this.loaded = true
							}).catch((err) => {
								this.debugMessage('<<THERAPY.VUE>> R2>CATCH')
								console.error(err);
								this.error = errMessage(err);
								errHandler(err);
							});

						} else {

							this.debugMessage('<<THERAPY.VUE>> R3');
							if (this.route == 'therapy.content' || this.route == 'therapy.stage') {
								this.debugMessage('<<THERAPY.VUE>> R3.1');
								this.debugObject ({params: this.$route.params});
								this.fetchStages(this.enrollment.id).then((v) => {
									this.debugMessage('<<THERAPY.VUE>> R3.1>THEN');
									this.debugObject ({params: this.$route.params});
									this.loaded = true
								}).catch((err) => {
									this.debugMessage('<<THERAPY.VUE>> R3.1>CATCH')
									console.error(err);
									this.error = errMessage(err);
									errHandler(err);
								});

							} else {

								this.debugMessage('<<THERAPY.VUE>> R3.2');
								let promises = [];
								// promises.push (this.fetchStages(this.enrollment.id))
								this.fetchStages(this.enrollment.id)
								promises.push (this.fetchSurveys(this.enrollment.id))
								promises.push (this.fetchCompleteSurveys(this.enrollment.id))
								//promises.push (this.fetchGraphs(this.enrollment.id))
								this.fetchGraphs(this.enrollment.id)

								if (promises.length > 0) {
									Promise.all(promises)
											.then((v) => {
												this.debugMessage('<<THERAPY.VUE>> R3.2>THEN');
												this.loaded = true
											})
											.catch((err) => {
												this.debugMessage('<<THERAPY.VUE>> R3.2>CATCH');
												console.error(err);
												this.error = errMessage(err);
												errHandler(err)
											});
								} else {

									this.debugMessage('<<THERAPY.VUE>> R3.2>FALL THROUGH');
									this.loaded = true;
								}
							}
						}
					}

				} else this.$router.push({name: 'therapy'});
			}
		},
		toggleTheme() {
			this.$store.state.users.theme = this.$store.state.users.theme === 'color' ? 'grayscale' : 'color';
  		}
	}
}
</script>
